import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { ImportComponent } from './import.component';
import { MatSnackBarModule } from '@angular/material';

@NgModule({
	declarations: [ImportComponent],
	imports: [
		MatIconModule,
		MatButtonModule,
		CommonModule,
		MatDialogModule,
		MatCheckboxModule,
		MatRadioModule,
		MatInputModule,
		FormsModule,
		MatProgressBarModule,
		MatTableModule,
		MatSnackBarModule,
		MatSelectModule,
		RouterModule.forChild([
			{
				path: '**',
				component: ImportComponent,
				data: SaveStateData
			}
		])
	]
})
export class ImportModule {}
